"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthPicker = exports.relativeMonth = exports.timeZone = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const core_1 = require("react-hook-schema/core");
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const hooks_1 = require("common/hooks");
const react_bootstrap_1 = require("react-bootstrap");
const react_select_1 = __importDefault(require("react-select"));
require("./searchDate.scss");
const dayjs_1 = require("utils/dayjs");
require("react-datepicker/dist/react-datepicker.css");
const hooks_2 = require("common/hooks");
exports.timeZone = "Asia/Tokyo";
const timezoneOffset = dayjs_1.dayjs.tz("1970-01-01", exports.timeZone).valueOf();
const systemTimezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
const timezoneAdjust = timezoneOffset - systemTimezoneOffset;
console.log({ timezoneAdjust, timezoneOffset, systemTimezoneOffset });
const isMobile = navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/);
const MonthInput = (0, react_1.forwardRef)(({ value, onClick, className, onMove, }, ref) => (react_1.default.createElement("div", { className: className, onClick: onClick, style: { position: "relative", padding: "6px 30px", textAlign: "center" } },
    onMove && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline", style: {
            position: "absolute",
            left: 0,
            top: 0,
            borderColor: "rgb(206, 212, 218)",
            height: 38,
            border: "none",
        }, onClick: (e) => {
            e.stopPropagation();
            onMove(-1);
        } },
        react_1.default.createElement("i", { className: "mdi mdi-chevron-left" }))),
    react_1.default.createElement("div", { style: { cursor: "pointer" } }, value),
    onMove && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline", style: {
            position: "absolute",
            right: 0,
            top: 0,
            borderColor: "rgb(206, 212, 218)",
            height: 38,
            border: "none",
        }, onClick: (e) => {
            e.stopPropagation();
            onMove(1);
        } },
        react_1.default.createElement("i", { className: "mdi mdi-chevron-right" }))))));
MonthInput.displayName = "CustomDatePickerInput";
const relativeMonth = (dateRange, value) => {
    const thisMonth = dayjs_1.dayjs
        .tz(dateRange === null || dateRange === void 0 ? void 0 : dateRange.$gte, exports.timeZone)
        .startOf("month")
        .add(value, "month");
    return {
        $gte: thisMonth.valueOf(),
        $lt: thisMonth.add(1, "month").valueOf(),
    };
};
exports.relativeMonth = relativeMonth;
const recentPeriod = (unit, value = 1) => {
    const today = dayjs_1.dayjs.tz(Date.now(), exports.timeZone).startOf("day").add(1, "day");
    return {
        $gte: today.subtract(value, unit).valueOf(),
        $lt: today.valueOf(),
    };
};
const dayInMilisecond = 24 * 3600 * 1000;
const MonthPicker = ({ dateRange, onChange, className, }) => {
    const onDateChangedHandler = (value) => {
        onChange((0, exports.relativeMonth)({ $gte: (value === null || value === void 0 ? void 0 : value.getTime()) + timezoneAdjust }, 0));
    };
    const onMove = (value) => {
        onChange((0, exports.relativeMonth)(dateRange, value));
        setTimeout(() => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
        }, 0);
    };
    const [locale] = (0, hooks_2.useContextLocale)();
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const ref = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_datepicker_1.default, { ref: ref, locale: locale, dateFormat: formatMessage("Calendar.YearMonthFormat"), dateFormatCalendar: formatMessage("Calendar.YearMonthFormat"), selected: (dateRange === null || dateRange === void 0 ? void 0 : dateRange.$gte) ? new Date(dateRange === null || dateRange === void 0 ? void 0 : dateRange.$gte) : undefined, onChange: onDateChangedHandler, onCalendarOpen: () => setIsOpen(true), onCalendarClose: () => setIsOpen(false), className: (0, classnames_1.default)(className, isOpen && "focused"), showMonthYearPicker: true, customInput: 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        react_1.default.createElement(MonthInput, Object.assign({}, {}, { onMove: onMove })) }));
};
exports.MonthPicker = MonthPicker;
const RangePicker = ({ dateRange, onChange, className, }) => {
    const onDateChangedHandler = ([start, end]) => onChange({
        $gte: (start === null || start === void 0 ? void 0 : start.getTime()) + timezoneAdjust,
        $lt: (end === null || end === void 0 ? void 0 : end.getTime()) + timezoneAdjust + dayInMilisecond,
    });
    const [locale] = (0, hooks_2.useContextLocale)();
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_datepicker_1.default, { selectsRange: true, locale: locale, dateFormat: "yyyy/MM/dd", dateFormatCalendar: formatMessage("Calendar.YearMonthFormat"), selected: (dateRange === null || dateRange === void 0 ? void 0 : dateRange.$gte) ? new Date(dateRange === null || dateRange === void 0 ? void 0 : dateRange.$gte) : undefined, startDate: (dateRange === null || dateRange === void 0 ? void 0 : dateRange.$gte) ? new Date(dateRange === null || dateRange === void 0 ? void 0 : dateRange.$gte) : undefined, endDate: (dateRange === null || dateRange === void 0 ? void 0 : dateRange.$lt) ? new Date((dateRange === null || dateRange === void 0 ? void 0 : dateRange.$lt) - dayInMilisecond) : undefined, onChange: onDateChangedHandler, onCalendarOpen: () => setIsOpen(true), onCalendarClose: () => setIsOpen(false), className: (0, classnames_1.default)(className, isOpen && "focused") }));
};
const focusedStyle = {
    borderColor: "#86b7fe",
    background: "#86b6fe20",
    boxShadow: "0 0 0 0.125rem rgb(113 170 255 / 25%)",
};
const normalStyle = {
    borderColor: "#ced4da",
    background: "none",
    boxShadow: "none",
};
const SearchDateSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const [mode, setMode] = (0, react_1.useState)(() => {
        if (!(value === null || value === void 0 ? void 0 : value.$gte) || !(value === null || value === void 0 ? void 0 : value.$lt)) {
            return "forTheLast30Days";
        }
        const start = dayjs_1.dayjs.tz(value === null || value === void 0 ? void 0 : value.$gte, exports.timeZone);
        const end = dayjs_1.dayjs.tz(value === null || value === void 0 ? void 0 : value.$lt, exports.timeZone);
        const isMonthLike = start.isSame(start.startOf("month")) && start.add(1, "month").isSame(end);
        return isMonthLike ? "month" : "range";
    });
    const options = [
        { value: "forTheLastWeek", label: "直近1週間" },
        { value: "forTheLast30Days", label: "直近30日" },
        { value: "thisMonth", label: "今月" },
        { value: "lastMonth", label: "先月" },
        { value: "month", label: "月" },
        { value: "range", label: "範囲" },
        { value: "all", label: "全期間" },
    ];
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(react_bootstrap_1.InputGroup, { className: "searchDate" },
            react_1.default.createElement(react_select_1.default, { options: options, value: options.find((option) => option.value === mode), onChange: (option) => {
                    const newMode = option === null || option === void 0 ? void 0 : option.value;
                    if (newMode === "thisMonth") {
                        registerProps.onChange((0, exports.relativeMonth)(null, 0));
                    }
                    else if (newMode === "lastMonth") {
                        registerProps.onChange((0, exports.relativeMonth)(null, -1));
                    }
                    else if (newMode === "month") {
                        registerProps.onChange((0, exports.relativeMonth)(value, 0));
                    }
                    else if (newMode === "forTheLastWeek") {
                        registerProps.onChange(recentPeriod("week"));
                    }
                    else if (newMode === "forTheLast30Days") {
                        registerProps.onChange(recentPeriod("day", 30));
                    }
                    else if (newMode === "all") {
                        registerProps.onChange(undefined);
                    }
                    setMode(newMode);
                }, className: "form-control col-sm-4 searchDateMode", styles: {
                    control: (provided, { menuIsOpen, isFocused }) => {
                        return Object.assign(Object.assign(Object.assign({}, provided), { "&:hover": focusedStyle }), (menuIsOpen || isFocused ? focusedStyle : normalStyle));
                    },
                } }),
            mode === "month" || mode === "thisMonth" || mode === "lastMonth" ? (react_1.default.createElement(exports.MonthPicker, Object.assign({ className: (0, classnames_1.default)("form-control", {
                    "has-error": fieldState.invalid,
                }), dateRange: value }, registerProps, { onChange: (v) => {
                    setMode("month");
                    registerProps.onChange(v);
                } }))) : (react_1.default.createElement(RangePicker, Object.assign({ className: (0, classnames_1.default)("form-control", {
                    "has-error": fieldState.invalid,
                }), dateRange: value }, registerProps, { onChange: (v) => {
                    setMode("range");
                    registerProps.onChange(v);
                } }))))));
};
SearchDateSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("DateDisplayComponent", (value) => {
    const { formatDate } = (0, hooks_1.useFormatter)();
    return value ? formatDate(value) + "" : "";
});
exports.default = SearchDateSchemaComponent;
